


















export default {
    data(this: any):any {
        return {
            isOpen: false,
        };
    },
    methods: {
        toggleOpen(this: any) {
            this.isOpen = !this.isOpen;
        },
    },
};
